import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Header from "./Header";
import Body from "./Body";
import Loader from "App/common/ui/Loader";
import {
  toggleBackupPlansCheckList,
  changeBackupPlansCheckList
} from "store/actions";
import Empty from "../Empty";

function Table(props) {
  const [sortCol, setSortCol] = useState({
    col: "planName",
    order: false
  });
  const [filteredData, setFilteredData] = useState([]);

  const toggleSort = col => {
    if (col === sortCol.col) {
      setSortCol(prevState => {
        return { ...prevState, order: !prevState.order };
      });
    } else {
      setSortCol({
        col: col,
        order: false
      });
    }
  };

  const headerCheckBox = () => {
    if (!props.backupPlan.backupPlans.loading) {
      const getAllPlanIds = filteredData.map(plan => plan.planId);
      if (props.backupPlan.backupPlans.checkList.length === 0) {
        props.changeBackupPlansCheckList(getAllPlanIds);
      } else {
        props.changeBackupPlansCheckList([]);
      }
    }
  };
  
  return (
    <div className="tabular_data_wrap listview_sec">
      <Header
        headerCheckBox={headerCheckBox}
        checked={
          props.backupPlan.backupPlans.checkList
            ? props.backupPlan.backupPlans.checkList.length !== 0
            : false
        }
        semiChecked={
          props.backupPlan.backupPlans.checkList
            ? props.backupPlan.backupPlans.checkList.length !==
              filteredData.length
            : false
        }
        checkList={props.backupPlan.backupPlans.checkList}
        toggleSort={toggleSort}
        sortCol={sortCol}
      />

      <div className="table_content_body">
        {!props.backupPlan.backupPlans.loading &&
        props.enums &&
        props.enums.ScheduleType ? (
          <Body
            sortCol={sortCol}
            search={props.search}
            getTotalMachines={props.getTotalMachines}
            totalMachines={props.totalMachines}
            setFilteredData={setFilteredData}
          />
        ) : (
          <Loader />
        )}
        {}
        {props.totalMachines === 0 &&
          !props.backupPlan.backupPlans.loading &&
          props.search !== "" && <Empty />}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    backupPlan: state.backupPlan,
    enums: state.common.enums
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleBackupPlansCheckList,
      changeBackupPlansCheckList
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Table);
